module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAYBAMAAABzQQKJAAAAAXNSR0IB2cksfwAAAC1QTFRFAAAAIHj/H3X/H3b/H3b/IHb/H3b/IHX/IHD/H3b/IHb/H3b/H3b/H3b/IHf/M9CdFQAAAA90Uk5TAEC/7/+A8GAQwFDzz9BPQQHwwAAAAJ1JREFUeJxjYGBgEDJxgQFnRQYYYHVBBgEwYZH0BrgShjJHGGvKAoQoA7snjJWCJMrA4czAscXFCchyQRYG8nqANjBMQhfmOOLCAIEowj2+WIWP3MAq7NuAVfgGWGgmunADVCVxwiewC/s0YBW+cgKrcK8PVmGOK1iFGXpBQYUesG6ggAUFOo5oELFrQAgXwyMNRxQzSKbABd0mQoQA3s02DAtDZo8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/video-active.png
// module id = 975
// module chunks = 0